export const TAX_REGIMES = {
  AU_GST: 'AU_GST',
  US_SALES_TAX: 'US_SALES_TAX'
}

const DEFAULT_TAX_REGIME = TAX_REGIMES.AU_GST

export const resolveTenantTaxRegime = ({ taxRegime, countryRegion } = {}) => {
  if (typeof taxRegime === 'string' && taxRegime.trim()) {
    const normalizedTaxRegime = taxRegime.trim().toUpperCase()
    return Object.values(TAX_REGIMES).includes(normalizedTaxRegime)
      ? normalizedTaxRegime
      : DEFAULT_TAX_REGIME
  }

  return String(countryRegion || '')
    .trim()
    .toUpperCase() === 'US'
    ? TAX_REGIMES.US_SALES_TAX
    : DEFAULT_TAX_REGIME
}

export const buildTaxDisplayPolicy = ({ taxRegime, countryRegion } = {}) => {
  const regime = resolveTenantTaxRegime({ taxRegime, countryRegion })
  const isAustralianTaxRegime = regime === TAX_REGIMES.AU_GST
  const isUSSalesTaxRegime = regime === TAX_REGIMES.US_SALES_TAX
  const primaryTaxLabel = isUSSalesTaxRegime ? 'Sales Tax' : 'GST'

  return {
    regime,
    isAustralianTaxRegime,
    isUSSalesTaxRegime,
    primaryTaxLabel,
    wetLabel: 'WET',
    showWet: isAustralianTaxRegime,
    showPrimaryTaxColumn: true,
    showTaxCodeSelector: isUSSalesTaxRegime,
    showTaxSuffix: isAustralianTaxRegime,
    usesAustralianTaxLabels: isAustralianTaxRegime,
    inclusiveTaxLabelSuffix: isAustralianTaxRegime
      ? '(inc GST)'
      : '(inc Sales Tax)',
    totalIncTaxLabel: 'Total (inc Tax)',
    noTaxAppliedLabel: isUSSalesTaxRegime
      ? 'Sales tax not applied'
      : 'No taxes applied',
    taxDoesNotApplyLabel: isUSSalesTaxRegime
      ? 'Sales tax does not apply'
      : 'GST does not apply'
  }
}

export const formatInclusiveTaxLabel = (baseLabel, policy) =>
  `${baseLabel} ${policy?.inclusiveTaxLabelSuffix || '(inc Tax)'}`.trim()
